import validate from '@/v2/validations/validate'
import { required, format } from '@/v2/validations/validators/general'

const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
const phoneRegex = /^(\([0-9]{3}\) |[0-9]{3}-)[0-9]{3}-[0-9]{4}$/

export const validators = {
  firstname: required({ message: 'Must have a first name' }),
  lastname: required({ message: 'Must have a last name' }),
  email: [
    required({ message: 'Must have an email' }),
    format({
      regex: emailRegex,
      message: 'Must have a valid email.',
    }),
  ],
  phone: [
    required({ message: 'Must have a phone number' }),
    format({
      regex: phoneRegex,
      message: 'Must have a valid phone number.',
    }),
  ],
}

const validator = values => validate(values, validators)

export default validator
